export default __webpack_public_path__ + "static/media/next_slice.1b9fe44c.svg";